import React from 'react';
import { Box } from '@material-ui/core';
import appStyle from '../../../appStyle';
import translate from '../../../services/Translation';

const IMAGE_WIDTH = 52;
const IMAGE_HEIGHT = 72;
const CONTAINER_HEIGHT = 500;

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: appStyle.paddings.l,
        paddingRight: appStyle.paddings.l,
        paddingBottom: appStyle.paddings.l,
        paddingTop: appStyle.paddings.xxl,
      },
    informationContainer: {
        backgroundColor: appStyle.colors.lightGrey,
        display: 'flex',
        flexDirection: 'column',
        height: CONTAINER_HEIGHT,
        paddingLeft: appStyle.paddings.l,
        paddingTop: appStyle.paddings.xxl,
    },
    errorImageContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    image: {
        height: IMAGE_HEIGHT,
        width: IMAGE_WIDTH,
    },
}
class NoMatchPageError extends React.Component {
    render() {
        return (
            <Box style={styles.container}>
            <Box style={styles.informationContainer}>
              <Box style={styles.errorImageContainer}>
                   <p>{translate('accessDenied')}</p>
                <img alt="access denied" src="assets/images/ressources/accessDenied.png" style={styles.image}/>
              </Box>
            </Box>
            </Box>
        )
    }
}

export default NoMatchPageError; 